module.exports = "<a class=\"tableGridExtendedCell\">\n  <span class=\"tableGridExtendedCell__icon\" ng-if=\"vm.icon\" uib-tooltip=\"{{vm.icon.tooltipText}}\">\n    <span class=\"icon\" aria-hidden=\"true\" ng-class=\"vm.icon.class\"></span>\n\t<span class=\"sr-only\">{{::vm.icon.class}}</span>\n  </span>\n  <span class=\"tableGridExtendedCell__value\" ng-class=\"vm.addClass\"\n        ng-bind-html=\"vm.cellValue | translate\">\n  </span>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/tableGridTextExtendedCell/tableGridTextExtendedCell.html
// module id = 589
// module chunks = 1